import React, { useCallback } from 'react';

import S from 'constants/string.const';
import { useScriptTagLink } from 'hooks/useScriptTag.hook';
import logger from 'utils/logger.util';

// eslint-disable-next-line import/extensions
import SCRIPT_BOOKING_START from './booking-start.js.script';

const L = logger('BookingStart'); // eslint-disable-line no-unused-vars

const BookingStart = () => {
  useScriptTagLink(SCRIPT_BOOKING_START);

  const handleChange = useCallback((ev) => void L.debug('handleChange()', ev), []);

  return (
    <article data-bem="BookingStart">
      <h2>Start</h2>

      <p>Hi there, let's start the booking process</p>

      <form id="form">
        <label>
          URL:{S.nbsp}
          <input name="url" onChange={handleChange} />
        </label>

        <label>
          parameter 1 name:{S.nbsp}
          <input name="pkey1" onChange={handleChange} />
        </label>

        <label>
          parameter 1 value:{S.nbsp}
          <input name="pval1" onChange={handleChange} />
        </label>

        <label>
          parameter 2 name:{S.nbsp}
          <input name="pkey2" onChange={handleChange} />
        </label>

        <label>
          parameter 2 value:{S.nbsp}
          <input name="pval2" onChange={handleChange} />
        </label>

        <a id="start" href={window.location}>
          Book an appointment
        </a>

        <textarea name="note" readOnly disabled />
      </form>
    </article>
  );
};

export default BookingStart;
